import React, { FC, useEffect, useMemo, useState } from 'react'
import styles from '../../styles'
import { Grid } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import { useLocation } from 'react-router'
import { DetailsContactData } from './types/detailsContactTypes'
import { getInformationsForClient, getInformationsForProspect } from './api/detailsContactApi'
import { CONTACT_CLIENT } from './utils/detailsContactConstants'
import Loader from '../../components/loader/Loader'
import InformationsContact from './components/InformationsContact'
import { typeContactEnum, typeSocieteEnum } from '../../enums/typeContactEnum'

export interface DetailsContactStateType {
	client_id: string
	prospect_type: string
	type: typeContactEnum | typeSocieteEnum
	prenom: string
	nom: string
}

const DetailsContact: FC = () => {
	const { classes, cx } = useStyles()
	const location = useLocation()
	const state = location.state as DetailsContactStateType

	const [loading, setLoading] = useState<boolean>(false)
	const [informations, setInformations] = useState<DetailsContactData>({})

	const isClientType = useMemo(() => CONTACT_CLIENT.includes(state.type), [state])

	useEffect(() => {
		const actionPromise: Promise<DetailsContactData> = isClientType ?
			getInformationsForClient(state.client_id, state.prospect_type)
			:
			getInformationsForProspect(state.client_id, state.prospect_type)
		setLoading(true)
		actionPromise
			.then(setInformations)
			.finally(() => setLoading(false))
	}, [isClientType, state])

	const titleStyle = cx(
		classes.title2,
		classes.titleContainer
	)

	return (
		<Grid container item className={classes.detailsContactContainer}>
			<Grid container item spacing="10px">
				<Grid container item>
					<span className={titleStyle}>
						<FormattedMessage
							id="detailsContact.title"
							defaultMessage="Coordonnées de l'interlocuteur commercial"
							description="Coordonnées de l'interlocuteur commercial"
						/>
					</span>
				</Grid>
				<Grid container item>
					<Grid container item justifyContent="center">
						{loading ? <Loader /> : <InformationsContact isClientType={isClientType} informations={informations} />}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	detailsContactContainer: {
		padding: '0px 20px'
	},
	titleContainer: {
		padding: 16
	}
}))

export default DetailsContact